interface TimelineStep {
  phase: string;
  title: string;
  description: string;
  duration: string;
}

interface ProcessTimelineProps {
  steps: TimelineStep[];
}

const ProcessTimeline = ({ steps }: ProcessTimelineProps) => {
  return (
    <section className="px-6 lg:px-12 py-24 lg:py-32 bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 lg:mb-24">
          <p className="text-xs font-cta font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-4">
            Our Process
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-headline font-bold tracking-tight text-primary mb-6">
            From Vision to Reality
          </h2>
          <p className="text-lg lg:text-xl font-body text-text-secondary max-w-3xl mx-auto">
            A structured approach that transforms strategic thinking into
            exceptional creative outcomes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-primary text-primary-foreground text-xl font-headline font-bold">
                  {step.phase}
                </div>
                <div className="flex-1 h-[1px] bg-border hidden lg:block" />
              </div>

              <h3 className="text-xl lg:text-2xl font-headline font-bold text-primary mb-3 tracking-tight">
                {step.title}
              </h3>

              <p className="text-sm lg:text-base font-body text-text-secondary leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessTimeline;